
export default {
    getInstalledPluginsData(state){
        return state.installedPlugins
    },
};
